import { useState } from "react";
import { useList, useEqSettings } from "./common";
import { MaterialList } from "./MaterialList";
import { ItemList } from "./ItemList";
import { NeedList } from "./NeedList";
import { HandoverList } from "./HandoverList";

const Box = ({ title, children, testid }) => (
  <div className="border border-slate-200 rounded-md p-3 space-y-3 bg-slate-50/50" data-testid={testid}>
    <div className="text-[11px] font-bold uppercase tracking-widest text-slate-500">{title}</div>{children}
  </div>
);

export const SiteMaterialPanel = ({ siteId }) => {
  const [settings] = useEqSettings();
  const [show, setShow] = useState("list");
  return (
    <Box title="Matériel du site" testid="site-material-panel">
      <div className="flex gap-1.5">{[["list", "Dotations"], ["needs", "Besoins"], ["sheets", "Fiches signées"]].map(([k, l]) => <button key={k} type="button" onClick={() => setShow(k)} className={`px-3 py-1 rounded-full text-xs font-semibold ${show === k ? "bg-[#0B2A7A] text-white" : "bg-white border border-slate-200"}`} data-testid={`site-material-${k}`}>{l}</button>)}</div>
      {show === "list" ? <MaterialList siteId={siteId} types={settings.material_types} /> : show === "needs" ? <NeedList kind="material" siteId={siteId} settings={settings} /> : <HandoverList kind="site" targetId={siteId} />}
    </Box>
  );
};

export const AgentEquipmentPanel = ({ agentId }) => {
  const [settings] = useEqSettings();
  const [catalog] = useList("/equipment/catalog");
  const [show, setShow] = useState("list");
  return (
    <Box title="Équipements de l'agent" testid="agent-equipment-panel">
      <div className="flex gap-1.5">{[["list", "Équipements remis"], ["needs", "Besoins"], ["sheets", "Fiches signées"]].map(([k, l]) => <button key={k} type="button" onClick={() => setShow(k)} className={`px-3 py-1 rounded-full text-xs font-semibold ${show === k ? "bg-[#0B2A7A] text-white" : "bg-white border border-slate-200"}`} data-testid={`agent-equipment-${k}`}>{l}</button>)}</div>
      {show === "list" ? <ItemList agentId={agentId} catalog={catalog} /> : show === "needs" ? <NeedList kind="equipment" agentId={agentId} catalog={catalog} settings={settings} /> : <HandoverList kind="agent" targetId={agentId} />}
    </Box>
  );
};
